export default "__VITE_ASSET__CmNgHUjV__"